import { React, useRef, useEffect } from 'react';
import GaugeChart from 'react-gauge-chart'
import Box from '@mui/material/Box';

export default function ProbabilityGauge(props) {
    const ref = useRef(true);

    useEffect(() => {
        const firstRender = ref.current;

        if (firstRender) {
            ref.current = false;
            //console.log('First Render');
        } else {
            //console.log('Not a first Render');
        }
    });

    return (
        <div>
            <Box display="flex"
                justifyContent="center"
                alignItems="center"
                noValidate
                marginTop="5px"

                autoComplete="off">
                <GaugeChart id="gauge-chart3"
                    nrOfLevels={5}
                    animate={ref.current}
                    colors={["#c02727", "#d77777", "#ffb200", "#98c800", "#bedc5e"]}
                    arcWidth={0.3}
                    percent={props.percent}
                    textColor='primary'
                    formatTextValue={(value) => props.text}
                    style={{ width: '315px' }}
                />
            </Box>
        </div>
    );

}

